// extracted by mini-css-extract-plugin
module.exports = {"date":"DateTime_date__GiMO5","right":"DateTime_right__UGP9H"};